import React, { useState, useMemo, useEffect } from 'react';
import LoadingIndicator from '../../../common/loading_indicator.jsx';
import { Button } from '../../../bootstrap/index.jsx';
import { FaIcon } from '../../../common/Icons.jsx';
import MonitoringReportInfo from './MonitoringReportInfo.jsx';
import { useQuery } from '@tanstack/react-query';
import { fetchJson } from '../../../../helpers/fetch.js';

import {
  monitoring_report_status_dashboard_workflow_data_path
} from '~/routes';

function TileInfo({ dataset: {widget_id, dashboard_id, project_id, dataset_id, source, name_item}, settings ,backClick = () => {} }) {
    const dataset_uuid = (dataset_id || "").split("_")[0]
    const params = source ? {source, project_id, dashboard_id, widget_id} : {project_id, dataset_uuid: dataset_uuid}
    const {data: reports, isLoading: loading} = useQuery({
        queryKey: ['dashboard_workflow_status',   {
                source: source || null,
                project_id,
                dashboard_id: source ? dashboard_id : null,
                widget_id: source ? widget_id : null,
                dataset_uuid: !source ? dataset_uuid : null
            }],
        queryFn: async () => {
            const res = await fetchJson(monitoring_report_status_dashboard_workflow_data_path(params), {method: 'POST', body: JSON.stringify({widget_settings: {settings}})});
            return res.data;
        },
        enabled: !!project_id && !!(source ? widget_id : dataset_id)
    })

    const totalReportCount = useMemo(()=>{
      return (reports || []).map((mr) => mr.project_reports.length).reduce((acc, val) => acc + val, 0)
    },[reports])

    return (
        <div className="flex-1">
          <div className="d-flex mb-2" style={{alignItems: 'center', fontSize: '2rem'}}>
            <Button type='default' className='pull-left mr-1' onClick={(e) => backClick()}>
              <FaIcon type='arrow-left' />
            </Button>
            <b className="mr-1">{name_item}</b>
            {` (${totalReportCount})`}
          </div>
          {loading ? <LoadingIndicator/> : 
            <div>
              {
                (reports || []).map((mr, idx) => <MonitoringReportInfo key={`mr-${idx}`} defaultExpand={idx === 0} source={source} {...mr} />)
              }
            </div>
          }
        </div>
    );
};

export default TileInfo;
